import { NgModule } from '@angular/core';
import { EmailInputDirective } from './email-input.directive';


@NgModule({
    imports: [],
    exports: [EmailInputDirective],
    declarations: [EmailInputDirective],
    providers: [],
})
export class EmailInputModule { }
